import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

/**
 * Page-body wrapper: a full-height flex column painted with the theme's
 * background and foreground. It used to carry the per-page theme opt-in as
 * well; <html> owns the theme scope now, so the shell is layout only.
 *
 * Spec: the 2026-08-09 v2 rebrand design spec under docs/superpowers/specs/
 * (filename predates the launch rename).
 */
export function V2PageShell({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex flex-1 flex-col bg-background text-foreground', className)}>
      {children}
    </div>
  )
}
